import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from "axios";
import useTableScroll from "../../useTableScroll";
import { Mensaje } from '../../mensajes2';
import { Dimmer } from '../../spinner';
import { DangerButton, SuccessButton } from '../../../ui/buttons/Button';
import { formatMoneda } from '../../../util/varios';
import useTableFijo from '../../useTableFijo';


const RetencionesxDeclaracion = props => {

    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [select, setSelect] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    // const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);
    const [records, setRecords] = useState([]);
    const [totRetenComer, setTotRetenComer] = useState(0.00);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const headCells = [
        { id: 'nombreagente', label: 'NOMBRE AGENTE', width: '270px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'numfactura', label: 'NRO. FACTURA', width: '100px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'periodo', label: 'PERIODO', width: '50px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'montoretenido', label: 'MONTO', width: '180px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
    ]

    let heightTabla = 320;
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, heightTabla);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.nombreagente.toLowerCase().includes(target.value.toLowerCase())
                            || x.numfactura.toLowerCase().includes(target.value.toLowerCase())
                            || x.periodo.toLowerCase().includes(target.value.toLowerCase())
                            || formatMoneda(x.montoretenido.toString().replace('.', ','), ',', '.', 2).includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })
    }

    const seleccionarRetencionesDjurada = (idcomer, anio, mes, tipo) => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'retencionesxdjurada';
        let condi = 'idcomercio = ' + idcomer + ' AND aniodecla = ' + anio
            + ' AND nummesdecla = ' + mes + ' AND tipodecla = ' + tipo;
        let orden = 'idretencion';

        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        console.log(endpoint)
        setActivate(true)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                var reten = [];
                var tot = parseFloat(0.00);
                for (let i = 0; i < response.data.length; i++) {
                    reten.push({
                        idretencion: response.data[i].idretencion,
                        nombreagente: response.data[i].nombreagente,
                        numfactura: response.data[i].numfactura,
                        periodo: response.data[i].periodo,
                        montoretenido: response.data[i].montoretenido
                    })
                    tot = Math.round((tot + parseFloat(response.data[i].montoretenido)) * 100) / 100;
                }
                setRecords(reten);
                setTotRetenComer(tot);
            }
            setActivate(false);
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })
    }
    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setActivo(true);
        setFilterFn({ fn: items => { return items; } });
    }
    const cancelar = () => {
        props.onHideCancelar();
        blanquear();
    }

    const cerrarModal = () => {
        if (props.onHideCancelar) { props.onHideCancelar(); }
        props.setShow(false)
        blanquear()
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
    }

    const seleccionarFila = (index) => (event) => {
        setItemSelect(index);
        setActivo(false);
        setSelect(parseInt(idefiscal));
        var idefiscal = recordsAfterPagingAndSorting()[index].idefiscal;
        var descriptor = recordsAfterPagingAndSorting()[index].descriptor;
        var anio = recordsAfterPagingAndSorting()[index].anio;
        var observaciones = recordsAfterPagingAndSorting()[index].observaciones;
        var statusorg = recordsAfterPagingAndSorting()[index].statusorg;
        var statuspresup = recordsAfterPagingAndSorting()[index].statuspresup;
        var statuspuc = recordsAfterPagingAndSorting()[index].statuspuc;
        var statuscat = recordsAfterPagingAndSorting()[index].statuscat;
        var idorganizacion = recordsAfterPagingAndSorting()[index].idorganizacion;
        var activo = recordsAfterPagingAndSorting()[index].activo;

        var datos = [];
        datos.push({
            idefiscal,
            descriptor,
            anio,
            observaciones,
            statusorg,
            statuspresup,
            statuspuc,
            statuscat,
            idorganizacion,
            activo
        })
        setValues(datos);
    };


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                //seleccionarRetencionesDjurada(props.idcomercio, props.anio, props.nmes, props.tipo);
                setRecords(props.retenxComer);
                setTotRetenComer(props.totalRet);
            }}
        >
            <Modal.Header className='header-azulGradiant'>
                <h3>Retenciones de la Declaración.</h3>
                <a
                    type='button'
                    onClick={cancelar}>
                    salir<i className="fa fa-times"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => mensaje.titulo === 'Exito.' ? cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="">
                    <div className="" style={{ height: "100%", backgroundColor: 'rgb(14, 86, 148)' }}>
                        <div className="content" >
                            <div className="container">
                                <div className="row col-md-12" style={{ height: "100%" }}>
                                    <div className="row" ></div>
                                    <div className="col-6 input-group input-group-sm m-0 mb-2 p-0">
                                        <input type='text'
                                            onChange={handleSearch} className="form-control search-input rounded-pill" />
                                    </div>
                                    <div className="col-12 m-0 p-0">
                                        <TblContainer >
                                            <TblHead />
                                            <tbody>
                                                {
                                                    records && recordsAfterPagingAndSorting().map((item, index) => (
                                                        <tr key={item.idretencion} style={{ padding: "0", cursor: 'pointer', backgroundColor: select === parseInt(item.idretencion) ? "lightskyblue" : itemSelect === index ? "lightskyblue" : "white" }} >
                                                            <td style={{ fontSize: "11px", textAlign: "left" }}>{item.nombreagente}</td>
                                                            <td style={{ fontSize: "11px", textAlign: "center" }}>{item.numfactura}</td>
                                                            <td style={{ fontSize: "11px", textAlign: "center" }}>{item.periodo}</td>
                                                            <td style={{ fontSize: "11px", textAlign: "right" }}>{formatMoneda(item.montoretenido.toString().replace('.', ','), ',', '.', 2)}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </TblContainer>
                                    </div>
                                    <div className="row col-md-7 w-100">

                                    </div>
                                    <div className="row col-md-6">
                                        <div className="col-md-12 py-3">
                                            <div className="row">
                                                <div className="col-md-9">
                                                    <label htmlFor="inputRitm" style={{ textAlign: "right", color:"white" }}>Monto Total: </label>
                                                </div>
                                                <div className="col-md-3" style={{ textAlign: "right", color:"white" }}>
                                                    <label htmlFor="inputRitm">{totRetenComer ? formatMoneda(totRetenComer.toString().replace('.', ','), ',', '.', 2) : "0,00"}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className='footer-azulGradiant'>
                {/*<SuccessButton onClick={seleccionarEfiscal} disabled={activo}>
                    Aceptar
                </SuccessButton>*/}
                <DangerButton onClick={cancelar}>
                    Salir
                </DangerButton>
            </Modal.Footer>
        </Modal >
    );
}
export default RetencionesxDeclaracion;